import { Typography } from "@mui/material";

import styles from "./styles";

const CreditsDescription = () => {
  return (
    <Typography variant="body2" color="text.secondary" sx={styles.description}>
      Power AI features across Bento — like pre-drafting personalized pitches
      for every brand in a campaign, or pulling insights on your account
      activity. AI actions use <strong>1 credit</strong> each.
    </Typography>
  );
};

export default CreditsDescription;
